export const namespaced = true

export const types = {
  TOGGLE_LEFT_NAV: 'TOGGLE_LEFT_NAV',
  TOGGLE_LEFT_NAV_MINI: 'TOGGLE_LEFT_NAV_MINI',
  TOGGLE_LEFT_NAV_ABOVE: 'TOGGLE_LEFT_NAV_ABOVE',

  TOGGLE_RIGHT_NAV: 'TOGGLE_RIGHT_NAV',
  TOGGLE_RIGHT_NAV_MINI: 'TOGGLE_RIGHT_NAV_MINI',
  TOGGLE_RIGHT_NAV_ABOVE: 'TOGGLE_RIGHT_NAV_ABOVE',
  TOGGLE_RIGHT_NAV_HAS_CONTENT: 'TOGGLE_RIGHT_NAV_HAS_CONTENT'
}

export const state = {
  left: {
    open: false,
    mini: false,
    isAbove: false
  },
  right: {
    open: false,
    mini: true,
    isAbove: false,
    hasContent: false
  }
}

export const mutations = {
  [types.TOGGLE_LEFT_NAV] (state, value) {
    if (state.left.open === value) {
      return
    }

    state.left.open = value
  },
  [types.TOGGLE_LEFT_NAV_MINI] (state, value) {
    if (state.left.mini === value) {
      return
    }

    state.left.mini = value
  },
  [types.TOGGLE_LEFT_NAV_ABOVE] (state, value) {
    if (state.left.isAbove === value) {
      return
    }

    state.left.isAbove = value
  },

  [types.TOGGLE_RIGHT_NAV] (state, value) {
    if (state.right.open === value) {
      return
    }
    state.right.open = value
  },
  [types.TOGGLE_RIGHT_NAV_MINI] (state, value) {
    if (state.right.mini === value) {
      return
    }

    state.right.mini = value
  },
  [types.TOGGLE_RIGHT_NAV_ABOVE] (state, value) {
    if (state.right.isAbove === value) {
      return
    }

    state.right.isAbove = value
  },
  [types.TOGGLE_RIGHT_NAV_HAS_CONTENT] (state, value) {
    if (state.right.hasContent === value) {
      return
    }

    state.right.hasContent = value === true
  }
}
